/* RESPONSIBLE TEAM: team-workflows */
import ContentEditorController from 'embercom/controllers/apps/app/content/edit';
export default ContentEditorController;
